<template>
  <div class="commentList">
    <!--操作栏-->
    <div class="action-bar">
      <el-input placeholder="请输入过滤词" size="small" class="param-input" v-model="params.content"></el-input>
      <el-button type="primary" size="small" @click="search">搜索</el-button>
      <el-button type="primary" size="small" @click="filterAction('add')">+添加过滤词</el-button>
    </div>

     <!--数据表格-->
    <el-table :data="tableData" style="width: 100%" border v-loading="loading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading" ref="multipleTable">
  
      <el-table-column prop="id" label="ID" align="center"></el-table-column>
      <el-table-column prop="word" label="过滤词" align="center"></el-table-column>
      <el-table-column prop="createdAt" label="创建时间" align="center">
           <template slot-scope="scope">
          <span>{{scope.row.createdAt | changeDate}}</span>
        </template>

      </el-table-column>
      
      <el-table-column label="操作" align="center" fixed="right">
        <template slot-scope="scope">
         <el-button type="danger" size="mini" class="el-icon-delete" @click="remove(scope.row.id)"></el-button>
        </template>
      </el-table-column>
    </el-table>
    <!--分页组件-->
    <el-pagination :page-sizes="[10, 15, 20, 30]" :current-page="params.pageNumber" :page-size="params.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total" background v-if="total > 1" @size-change="changeSize" @current-change="changeCurrent"></el-pagination>

    <!--新增过滤词弹窗-->
    <add-filter ref="addFilter" @handlerfilterList="handlerfilterList"></add-filter>
  </div>
</template>
<script>
import API from '@/api'
import AddFilter from './components/addFilter'
import { paramsFilter } from '@/utils/global'
export default {
  data() {
    return {
      // 表格数据加载动画
      loading: false,
      total: 0,
      tableData: [],
      // 请求过滤词列表参数
      params: {
        pageNumber: 1,
        pageSize: 10,
        content: ''
      }
    }
  },
  created() {
    this.getfilterlist()
  },
  components: {
    AddFilter
  },
  methods: {
    // 请求过滤词列表
    getfilterlist() {
      this.loading = true;
      let params = paramsFilter(this.params)
      API.filterList(params).then(res => {
        this.loading = false
        if (res.code === 200 && res.data.list) {
          this.tableData = res.data.list
          this.total = res.data.total
        } else {
          this.tableData = []
          this.total = 0
        }
      }).catch(() => {
        this.loading = false
        this.tableData = []
      })
    },
    // 搜索过滤词
    search() {
      this.params.pageNumber = 1
      this.getfilterlist()
    },
    // 新增过滤词
    filterAction(type) {
      this.$refs.addFilter.open(type);
    },
    // 删除过滤词
    remove(id) {
      this.$confirm('确定要删除当前过滤词吗？', '删除提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        API.filterDelete({ ids: [id] }).then(res => {
          if (res.code === 200) {
            this.$message({
              message: '删除成功！',
              type: 'success'
            });
            this.getfilterlist()
          } else {
            this.$message.error('删除失败！');
          }
        })
      })
    },
    // 监听添加成功过后重新拉取数据
    handlerfilterList() {
      this.params.pageNumber = 1
      this.params.pageSize = 10
      this.getfilterlist()
    },
    // pageSize发生变化触发
    changeSize(size) {
      this.params.pageSize = size
      this.params.pageNumber = 1
      this.getfilterlist()
    },
    // 当前页发生变化触发
    changeCurrent(pageNumber) {
      this.params.pageNumber = pageNumber
      this.getfilterlist(this.params)
    }
  },
  
}
</script>
<style scoped>

</style>
